/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        AgentVariableDistribution200ResponseInner,
        CompetitiveGames,
        CompetitiveGamesAggregate,
        PatchedCompetitiveGames,
    } from '../models/index';

            export interface CompetitiveGamesAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                aggregates?: Array<string>;
                draft_checked_at?: string;
                draft_parsed?: boolean;
                game_id?: string;
                having?: object;
                id?: string;
                index_on?: string;
                league?: string;
                map?: string;
                map_selection?: string;
                metrics?: Array<string>;
                phase?: string;
                series_id?: number;
                smokes_yolonet_version?: string;
                split?: string;
                team1?: string;
                team2?: string;
                utils_yolonet_version?: string;
                vlr_id?: number;
                winner?: string;
            }

            export interface CompetitiveGamesFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                draft_checked_at?: string;
                draft_parsed?: boolean;
                game_id?: string;
                id?: string;
                league?: string;
                map?: string;
                map_selection?: string;
                phase?: string;
                series_id?: number;
                smokes_yolonet_version?: string;
                split?: string;
                team1?: string;
                team2?: string;
                utils_yolonet_version?: string;
                vlr_id?: number;
                winner?: string;
            }

            export interface CompetitiveGamesGetRequest {
                id: string;
            }

            export interface CompetitiveGamesListRequest {
                additional_filters?: object;
                annotations?: Array<string>;
                draft_checked_at?: string;
                draft_parsed?: boolean;
                game_id?: string;
                id?: string;
                league?: string;
                map?: string;
                map_selection?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                phase?: string;
                series_id?: number;
                smokes_yolonet_version?: string;
                split?: string;
                team1?: string;
                team2?: string;
                utils_yolonet_version?: string;
                vlr_id?: number;
                winner?: string;
            }

            export interface CompetitiveGamesPatchRequest {
                id: string;
                patched_competitive_games?: PatchedCompetitiveGames;
            }

            export interface CompetitiveGamesVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                draft_checked_at?: string;
                draft_parsed?: boolean;
                game_id?: string;
                id?: string;
                league?: string;
                map?: string;
                map_selection?: string;
                phase?: string;
                series_id?: number;
                smokes_yolonet_version?: string;
                split?: string;
                team1?: string;
                team2?: string;
                utils_yolonet_version?: string;
                vlr_id?: number;
                winner?: string;
            }

        /**
        * 
        */
            export class CompetitiveGamesApi extends runtime.BaseAPI {

            /**
            */
            async competitiveGamesAggregateRaw(requestParameters: CompetitiveGamesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveGamesAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling competitiveGamesAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveGamesAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.draft_checked_at !== undefined) {
                            queryParameters['draft_checked_at'] = requestParameters.draft_checked_at;
                    }

                    if (requestParameters.draft_parsed !== undefined) {
                            queryParameters['draft_parsed'] = requestParameters.draft_parsed;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.map_selection !== undefined) {
                            queryParameters['map_selection'] = requestParameters.map_selection;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.phase !== undefined) {
                            queryParameters['phase'] = requestParameters.phase;
                    }

                    if (requestParameters.series_id !== undefined) {
                            queryParameters['series_id'] = requestParameters.series_id;
                    }

                    if (requestParameters.smokes_yolonet_version !== undefined) {
                            queryParameters['smokes_yolonet_version'] = requestParameters.smokes_yolonet_version;
                    }

                    if (requestParameters.split !== undefined) {
                            queryParameters['split'] = requestParameters.split;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.utils_yolonet_version !== undefined) {
                            queryParameters['utils_yolonet_version'] = requestParameters.utils_yolonet_version;
                    }

                    if (requestParameters.vlr_id !== undefined) {
                            queryParameters['vlr_id'] = requestParameters.vlr_id;
                    }

                    if (requestParameters.winner !== undefined) {
                            queryParameters['winner'] = requestParameters.winner;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGames/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: CompetitiveGamesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveGamesAggregate>> {
                    const response = await this.competitiveGamesAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGamesFieldValuesRaw(requestParameters: CompetitiveGamesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling competitiveGamesFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveGamesFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.draft_checked_at !== undefined) {
                            queryParameters['draft_checked_at'] = requestParameters.draft_checked_at;
                    }

                    if (requestParameters.draft_parsed !== undefined) {
                            queryParameters['draft_parsed'] = requestParameters.draft_parsed;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.map_selection !== undefined) {
                            queryParameters['map_selection'] = requestParameters.map_selection;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.phase !== undefined) {
                            queryParameters['phase'] = requestParameters.phase;
                    }

                    if (requestParameters.series_id !== undefined) {
                            queryParameters['series_id'] = requestParameters.series_id;
                    }

                    if (requestParameters.smokes_yolonet_version !== undefined) {
                            queryParameters['smokes_yolonet_version'] = requestParameters.smokes_yolonet_version;
                    }

                    if (requestParameters.split !== undefined) {
                            queryParameters['split'] = requestParameters.split;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.utils_yolonet_version !== undefined) {
                            queryParameters['utils_yolonet_version'] = requestParameters.utils_yolonet_version;
                    }

                    if (requestParameters.vlr_id !== undefined) {
                            queryParameters['vlr_id'] = requestParameters.vlr_id;
                    }

                    if (requestParameters.winner !== undefined) {
                            queryParameters['winner'] = requestParameters.winner;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGames/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: CompetitiveGamesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.competitiveGamesFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGamesGetRaw(requestParameters: CompetitiveGamesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitiveGames>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling competitiveGamesGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGames/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: CompetitiveGamesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitiveGames> {
                    const response = await this.competitiveGamesGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGamesListRaw(requestParameters: CompetitiveGamesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveGames>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.draft_checked_at !== undefined) {
                            queryParameters['draft_checked_at'] = requestParameters.draft_checked_at;
                    }

                    if (requestParameters.draft_parsed !== undefined) {
                            queryParameters['draft_parsed'] = requestParameters.draft_parsed;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.map_selection !== undefined) {
                            queryParameters['map_selection'] = requestParameters.map_selection;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.phase !== undefined) {
                            queryParameters['phase'] = requestParameters.phase;
                    }

                    if (requestParameters.series_id !== undefined) {
                            queryParameters['series_id'] = requestParameters.series_id;
                    }

                    if (requestParameters.smokes_yolonet_version !== undefined) {
                            queryParameters['smokes_yolonet_version'] = requestParameters.smokes_yolonet_version;
                    }

                    if (requestParameters.split !== undefined) {
                            queryParameters['split'] = requestParameters.split;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.utils_yolonet_version !== undefined) {
                            queryParameters['utils_yolonet_version'] = requestParameters.utils_yolonet_version;
                    }

                    if (requestParameters.vlr_id !== undefined) {
                            queryParameters['vlr_id'] = requestParameters.vlr_id;
                    }

                    if (requestParameters.winner !== undefined) {
                            queryParameters['winner'] = requestParameters.winner;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGames/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: CompetitiveGamesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveGames>> {
                    const response = await this.competitiveGamesListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGamesPatchRaw(requestParameters: CompetitiveGamesPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitiveGames>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling competitiveGamesPatch.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                    headerParameters['Content-Type'] = 'application/json';

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGames/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
                                body: requestParameters.patched_competitive_games,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async patch(requestParameters: CompetitiveGamesPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitiveGames> {
                    const response = await this.competitiveGamesPatchRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveGamesVariableDistributionRaw(requestParameters: CompetitiveGamesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AgentVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling competitiveGamesVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling competitiveGamesVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling competitiveGamesVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling competitiveGamesVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.draft_checked_at !== undefined) {
                            queryParameters['draft_checked_at'] = requestParameters.draft_checked_at;
                    }

                    if (requestParameters.draft_parsed !== undefined) {
                            queryParameters['draft_parsed'] = requestParameters.draft_parsed;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.map_selection !== undefined) {
                            queryParameters['map_selection'] = requestParameters.map_selection;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.phase !== undefined) {
                            queryParameters['phase'] = requestParameters.phase;
                    }

                    if (requestParameters.series_id !== undefined) {
                            queryParameters['series_id'] = requestParameters.series_id;
                    }

                    if (requestParameters.smokes_yolonet_version !== undefined) {
                            queryParameters['smokes_yolonet_version'] = requestParameters.smokes_yolonet_version;
                    }

                    if (requestParameters.split !== undefined) {
                            queryParameters['split'] = requestParameters.split;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.utils_yolonet_version !== undefined) {
                            queryParameters['utils_yolonet_version'] = requestParameters.utils_yolonet_version;
                    }

                    if (requestParameters.vlr_id !== undefined) {
                            queryParameters['vlr_id'] = requestParameters.vlr_id;
                    }

                    if (requestParameters.winner !== undefined) {
                            queryParameters['winner'] = requestParameters.winner;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveGames/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: CompetitiveGamesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AgentVariableDistribution200ResponseInner>> {
                    const response = await this.competitiveGamesVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
